import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-unauthorized",
  templateUrl: "./unauthorized.component.html",
  styleUrls: ["./unauthorized.component.scss"],
  imports: [TranslateModule, CommonModule],
  standalone: true,
})
export class UnauthorizedComponent {
  private router = inject(Router);
  private translate = inject(TranslateService);

  goBack(): void {
    this.router.navigate(["/dashboard"]);
  }

  goHome(): void {
    this.router.navigate([""]);
  }
}
